import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class HomeLoginStore {}

export enum HomeLoginStoreKeys {}
